import { Button, Icon, Typography } from '@material-ui/core'
import React from 'react'
import { FormattedMessage } from 'react-intl'

import RolesPermissionsTable from './RolesPermissionsTable'
import {
  CreatingDialogStateProvider,
  useCreatingRoleDialogState,
} from './useCreatingRoleDialogState'
import NetworkError from 'app/components/NetworkError'
import { useIsOnline } from 'commons/useIsOnline'

import LargeToolbar from 'app/components/LargeToolbar'
import ContentToolbarPage from 'app/components/ContentToolbarPage'
import { PaidPlanAccess } from 'app/auth/paidPlanAccess'
import PaidPlanAccessFullScreen from 'app/auth/PaidPlanAccessFullScreen'

const ContentToolbar = ({ onAddRolesPermissions }) => {
  return (
    <LargeToolbar
      content={
        <>
          <Typography variant="h6">
            <FormattedMessage id="rolesPermissions.header.label" />
          </Typography>
        </>
      }
      right={
        <>
          <Button
            className="ml-auto"
            color="secondary"
            variant="outlined"
            onClick={onAddRolesPermissions}
          >
            <Icon>add</Icon>
            <FormattedMessage id="rolesPermissions.action.create" />
          </Button>
        </>
      }
    />
  )
}

const RolesPermissionsPage = () => {
  const { setState } = useCreatingRoleDialogState()
  const [isOnline] = useIsOnline()
  const handleClickCreate = () => {
    setState({ isOpenCreatingRoleDialog: true })
  }

  if (!isOnline) {
    return <NetworkError onRetryFetching={() => {}} />
  }
  return (
    <PaidPlanAccess freePlanComponent={<PaidPlanAccessFullScreen />}>
      <ContentToolbarPage
        isFitViewPort
        contentToolbar={
          <ContentToolbar onAddRolesPermissions={handleClickCreate} />
        }
        content={
          <RolesPermissionsTable onAddRolesPermissions={handleClickCreate} />
        }
      />
    </PaidPlanAccess>
  )
}

const RolesPermissions = ({ match }) => (
  <CreatingDialogStateProvider>
    <RolesPermissionsPage />
  </CreatingDialogStateProvider>
)

export default RolesPermissions
